import React, { PureComponent } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { postLike, getTopicList } from '@app-core/posts/actions'
import {
  getPost,
  resetPost,
  getReply,
  postReply,
  deleteReply,
  resetPostReplyImages,
  setPostReplyImages,
  postImgReply,
  postImageReplaySuccess,
  postImageReplayFailed,
  postUserFollow,
  deletePost,
} from '@app-core/post/actions'
import {
  closeR18Alert,
  openLoginAlert,
  closeLoginAlert,
  setReplyId,
  openReplyBar,
  closeReplyBar,
  recallPost,
  recallReply,
  reportPost,
  reportReply,
} from '@app-core/app/actions'
import { initialState as appInitialState } from '@app-core/app/reducer'
import { initialState as postInitialState } from '@app-core/post/reducer'

import { postUrl } from '@libs/appUrl'
import { isSecretOrSexClas, getEditorUrl } from '@libs/postTools'
import { compose, connect, withState, withContext, withHandlers } from '@hocs'

import LayoutContent from '@components/LayoutContent'
import WebPost from './components/WebPost'

// prettier-ignore
import {LikeActionType, trackArticleBottomAnchorLikeEvent} from '@libs/eventTracking/article'

import dynamic from 'next/dynamic'
import { withArticleEventTracking } from '@features/post/hocs/withArticleEventTracking'
import { dispatchCustomEvent, NavigationEvents } from '@libs/customEvents'
import { checkIsGuest } from '@libs/auth-utils'
import R18Alert from '@components/R18Alert'

const BottomBar = dynamic(() => import('@components/BottomBar'), { ssr: false })
const OptionMenu = dynamic(() => import('@components/OptionMenu'), { ssr: false })
const UploadBar = dynamic(() => import('@components/UploadBar'), { ssr: false })

const ArticleLayoutContent = styled(LayoutContent)`
  background-color: #fff;
`

const HIDE_COMMENT_POST_IDS = ['japan.1538880', 'japan.1538881']

// @refresh reset
class ArticleContainer extends PureComponent {
  static defaultProps = {
    isApp: false,
    isUploading: false,
    displayAD: false,
    app: appInitialState,
    post: postInitialState,
    currentReplyId: 0,
    replyBarIsOpen: false,
    setReplyId: () => false,
    closeReplyBar: () => false,
    loginAlertIsOpen: false,
    closeLoginAlert: () => false,
    optionType: '',
    displayOptionMenu: () => false,
    eventCategories: [],
    isAmp: false,
  }

  constructor(props) {
    super(props)
    this.state = {
      isHideArticleSomeMessage: true,
    }
  }

  componentDidMount() {
    this.props.getPost(this.props.postId)
    this.props.getReply()
    this.props.getTopicList({ postId: this.props.postId })

    if (HIDE_COMMENT_POST_IDS.includes(this.props.postId)) {
      this.setState({ isHideArticleSomeMessage: true })
    } else if (this.props.isApp) {
      this.setState({ isHideArticleSomeMessage: !!window.appShouldHideInteractionComponents })
    } else {
      this.setState({ isHideArticleSomeMessage: false })
    }
  }

  checkIsAdmin = () => {
    const { currentUser } = this.props
    return currentUser.getIn(['userInfo', 'role', 'admin']) == 1
  }

  getPost = () => this.props.post.getIn(['post', 'data'])

  getComments = () => this.props.post.getIn(['post', 'comments'])

  getCurrentReplyId = () => this.props.app.getIn(['replyBar', 'currentReplyId'], 0)

  handleClose = () => this.props.displayOptionMenu()

  _handleEditor = () => {
    const toPath = getEditorUrl(this.getPost())
    dispatchCustomEvent(NavigationEvents.ENTER_EDITOR, { toPath })
    window.open(toPath)
    this.props.displayOptionMenu()
  }

  _handleDelete = (replyID) => async () => {
    const { optionType, post, deletePost, deleteReply } = this.props
    const postID = post.getIn(['post', 'data', 'postID'])

    if (optionType === 'reply') {
      if (window.confirm('是否刪除回應?')) {
        deleteReply({ postID, replyID })
        this.handleClose()
      }
    } else if (optionType === 'post') {
      if (window.confirm('是否刪除貼文?')) {
        return deletePost({ postID })
      }
    }
  }

  renderOverLay = () => {
    const {
      app,
      post,
      optionType,
      recallReply,
      recallPost,
      postID,
      replyID,
      text,
      reportPost,
      reportReply,
      currentUser,
    } = this.props

    const isAdmin = this.checkIsAdmin()
    const isUploading = post.getIn(['post', 'isUploading'], false)
    const r18Alert = app.getIn(['r18Alert', 'isOpen'], false)
    const hide =
      optionType === 'reply'
        ? ['facebook', 'messenger', 'line', 'copylink', 'block', 'feedback']
        : ['block', 'feedback']
    const currentReplyIndex = post
      .getIn(['post', 'comments'])
      .findIndex((comment) => comment.get('replyID') === replyID)
    const userInfo = currentUser.getIn(['userInfo'])
    const isReplyAuthor =
      currentReplyIndex === -1
        ? false
        : post.getIn(['post', 'comments', currentReplyIndex, 'userInfo', 'mid']) ===
          userInfo.get('mid')

    return (
      <>
        {isUploading ? <UploadBar data={post} /> : null}
        {r18Alert ? <R18Alert /> : null}
        <OptionMenu
          isOpen={optionType !== ''}
          handleClose={this.handleClose}
          shareType={optionType}
          recallType={optionType}
          deleteType={optionType}
          reportType={optionType}
          sharePost={this.getPost()}
          url={postUrl(post.getIn(['post', 'data', 'postID']))}
          userId={userInfo.get('mid')}
          hide={hide}
          onClickDelete={this._handleDelete(replyID)}
          isReplyAuthor={isReplyAuthor}
          onClickEdit={this._handleEditor}
          recallPost={recallPost}
          recallReply={recallReply}
          replyID={replyID}
          isAdmin={isAdmin}
          onClickReport={optionType === 'reply' ? reportReply : reportPost}
          postID={postID}
          text={text}
        />
      </>
    )
  }

  renderWebBottomBar = () => {
    const postData = this.getPost()
    const postComments = this.getComments()
    const currentReplyId = this.getCurrentReplyId()
    const { postID = '', like = 0, saved = 0, reply = 0 } = postData.toJS()
    const maxReply = Math.max(reply, postComments.size, 0)
    const { closeLoginAlert, setReplyId, closeReplyBar, replyBarIsOpen, loginAlertIsOpen } =
      this.props
    let replyTarget = ''
    if (currentReplyId !== 0) {
      const replyIndex = postComments.findIndex((reply) => reply.get('replyID') === currentReplyId)
      if (replyIndex > -1) {
        const currentReply = postComments.get(replyIndex)
        if (currentReply) {
          replyTarget = `:${currentReply.getIn(['userInfo', 'name'], '')}`
        }
      }
    }

    if (!postID || this.state.isHideArticleSomeMessage) {
      return null
    }

    return (
      <BottomBar
        postId={postID}
        post={postData}
        likeNum={like}
        replyNum={maxReply}
        savedNum={saved}
        setReplyId={setReplyId}
        closeReplyBar={closeReplyBar}
        replyBarIsOpen={replyBarIsOpen}
        loginAlertIsOpen={loginAlertIsOpen}
        closeLoginAlert={closeLoginAlert}
        replyTarget={replyTarget}
        via="Post"
      />
    )
  }

  renderPost() {
    const { isApp, currentUser, displayOptionMenu, optionType, isAmp } = this.props
    const userInfo = currentUser.getIn(['userInfo'])
    const { isAdmin } = this.state

    return (
      <WebPost
        isApp={isApp}
        isHideArticleSomeMessage={this.state.isHideArticleSomeMessage}
        displayOptionMenu={displayOptionMenu}
        optionType={optionType}
        isAdmin={isAdmin}
        userId={userInfo.get('mid')}
        isAmp={isAmp}
      />
    )
  }

  render() {
    const { isApp, eventCategories } = this.props

    return (
      <ArticleLayoutContent
        isApp={isApp}
        isArticlePage={true}
        renderOverLay={this.renderOverLay}
        renderBottomBar={this.renderWebBottomBar}
        hasNavigation={!isApp}
        eventCategories={eventCategories}
      >
        {this.renderPost()}
      </ArticleLayoutContent>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isGuest: checkIsGuest(state.currentUser.getIn(['userInfo', 'type'])),
    ...state,
  }
}
const mapDispatchToProps = {
  closeR18Alert,
  openLoginAlert,
  closeLoginAlert,
  setReplyId,
  openReplyBar,
  closeReplyBar,
  resetPost,
  getReply,
  postReply,
  deleteReply,
  postImgReply,
  postImageReplaySuccess,
  postImageReplayFailed,
  setPostReplyImages,
  resetPostReplyImages,
  postLike,
  postUserFollow,
  recallPost,
  recallReply,
  reportPost,
  reportReply,
  deletePost,
  getTopicList,
  getPost,
}
const mergeProps = (state, dispatchProps, ownProps) => {
  const { isGuest } = state
  const { router = {}, isApp } = ownProps
  const { currentUser, app, post } = state
  const {
    openLoginAlert,
    setReplyId,
    openReplyBar,
    closeReplyBar,
    getReply,
    postReply,
    deleteReply,
    postImgReply,
    postImageReplaySuccess,
    postImageReplayFailed,
    setPostReplyImages,
    resetPostReplyImages,
    postLike,
    postUserFollow,
    recallPost,
    recallReply,
    reportPost,
    reportReply,
  } = dispatchProps

  const currentReplyId = app.getIn(['replyBar', 'currentReplyId'], 0)

  const isSecretOrSex = isSecretOrSexClas(post.getIn(['post', 'data', 'clas'], []))

  return {
    ...state,
    ...dispatchProps,
    ...ownProps,
    isGuest,
    router,
    currentUser,
    isUploading: post.getIn(['post', 'isUploading'], false),
    loginAlertIsOpen: app.getIn(['loginAlert', 'isOpen'], false),
    setReplyId: (replyID = 0) => {
      closeReplyBar()
      setReplyId(replyID)
      if (isGuest) {
        openLoginAlert()
      } else {
        openReplyBar()
      }
    },
    replyBarIsOpen: app.getIn(['replyBar', 'isOpen']),
    postReply: async ({ postID, text = '', imgList = [] }) => {
      if (isGuest) {
        openLoginAlert()
      } else {
        await resetPostReplyImages()
        if (imgList.length > 0) {
          await setPostReplyImages(imgList)
          const imagesUpload = []
          imgList.map((imgObj, index) => {
            imagesUpload.push(
              postImgReply({
                postID,
                replyID: currentReplyId,
                index,
                imgObj,
                secret: isSecretOrSex ? 1 : 0,
              }),
            )
          })
          try {
            const results = await Promise.all(imagesUpload)
            postImageReplaySuccess(results)
          } catch (err) {
            postImageReplayFailed(err)
          }
          return getReply({ postID })
        } else if (text) {
          const result = await postReply({
            postID,
            replyID: currentReplyId,
            text,
            secret: isSecretOrSex ? 1 : 0,
          })
          getReply({ postID })
          return result
        }
      }
    },
    deleteReply: async ({ postID, replyID = -1 }) => {
      if (replyID !== -1) {
        await deleteReply({ postID, replyID })
        getReply({ postID })
      }
    },
    postLike: ({ postID, replyID = 0, isLike }) => {
      postLike({ postID, replyID, isLike })
      // 'like/unlike comment' and 'like/unlike post' will both trigger postLike,
      // only trackArticleBottomAnchorLikeEvent when 'like/unlike post', which replyId will be 0
      if (replyID === 0) {
        trackArticleBottomAnchorLikeEvent(
          post.getIn(['post', 'data']).toJS(),
          isLike ? LikeActionType.LIKE : LikeActionType.UNLIKE,
        )
      }
    },
    followPoster: (followID) => followID && postUserFollow({ followID }),
    unfollowPoster: (followID) => followID && postUserFollow({ followID, follow: 0 }),
    recallPost: () => {
      recallPost({
        postID: post.getIn(['post', 'data', 'postID']),
        via: isApp ? 'app' : 'web',
      })
    },
    recallReply: (replyID) => {
      recallReply({
        postID: post.getIn(['post', 'data', 'postID']),
        replyID,
      })
    },
    reportPost: () => reportPost({ post: post.getIn(['post', 'data']).toJS() }),
    reportReply: (postID, replyID, text) => reportReply({ postID, replyID, text }),
  }
}

const contextPropTypes = {
  isApp: PropTypes.bool,
  isGuest: PropTypes.bool,
  router: PropTypes.any,
  post: PropTypes.any,
  currentUser: PropTypes.any,
  postLike: PropTypes.func,
  postReply: PropTypes.func,
  deleteReply: PropTypes.func,
  followPoster: PropTypes.func,
  unfollowPoster: PropTypes.func,
  setReplyId: PropTypes.func,
  closeReplyBar: PropTypes.func,
  closeR18Alert: PropTypes.func,
  displayOptionMenu: PropTypes.func,
  recallPost: PropTypes.func,
  recallReply: PropTypes.func,
  reportPost: PropTypes.func,
  reportReply: PropTypes.func,
  fetchPost: PropTypes.func,
  eventCatgories: PropTypes.array,
}
const mapPropsToContext = (ownProps) => {
  return {
    isApp: ownProps.isApp,
    isGuest: ownProps.isGuest,
    router: ownProps.router,
    post: ownProps.post,
    currentUser: ownProps.currentUser,
    postLike: ownProps.postLike,
    postReply: ownProps.postReply,
    deleteReply: ownProps.deleteReply,
    followPoster: ownProps.followPoster,
    unfollowPoster: ownProps.unfollowPoster,
    setReplyId: ownProps.setReplyId,
    closeReplyBar: ownProps.closeReplyBar,
    closeR18Alert: ownProps.closeR18Alert,
    displayOptionMenu: ownProps.displayOptionMenu,
    recallPost: ownProps.recallPost,
    recallReply: ownProps.recallReply,
    reportPost: ownProps.reportPost,
    reportReply: ownProps.reportReply,
    fetchPost: ownProps.fetchPost,
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withState('optionType', 'setOptionType', ({ optionType = '' }) => optionType),
  withState('postID', 'setPostID', ({ postID = '' }) => postID),
  withState('replyID', 'setReplyID', ({ replyID = '' }) => replyID),
  withState('text', 'setText', ({ text = '' }) => text),
  withHandlers({
    displayOptionMenu:
      ({ setOptionType, setPostID, setReplyID, setText }) =>
      (optionType = '', otherProperty) => {
        setOptionType(optionType)
        if (otherProperty) {
          setPostID(otherProperty.post.getIn(['postID']))
          setReplyID(otherProperty.replyID)
          setText(otherProperty.text)
        }
      },
  }),
  withContext({ optionType: PropTypes.string.isRequired }, ({ optionType }) => ({ optionType })),
  withContext(contextPropTypes, mapPropsToContext),
  withArticleEventTracking,
)(ArticleContainer)
